import { AICC_SANDBOX_LESSON } from "constants/aiccPromptSandbox";
import { AiccSandboxCursorRequest, AiccSandboxLessonRequest } from "types/dto/request/aiccPromptSandbox";
import { AiccSandboxCursor } from "types/model/aiccPromptSandbox";
import { LESSON_NO_SCRIPTS, LESSON_SUMMARY } from "../configs";

export interface SandboxLessonState {
  level: number;
  lesson: number;
  scriptIndex: number;
}

export const EMPTY_LESSON: SandboxLessonState = {
  level: AICC_SANDBOX_LESSON.defaultLevel,
  lesson: AICC_SANDBOX_LESSON.defaultLesson,
  scriptIndex: AICC_SANDBOX_LESSON.defaultScriptIndex,
};

export interface SandboxLessonRequest {
  lesson?: AiccSandboxLessonRequest;
  error?: string;
}

export const NO_LESSON: SandboxLessonRequest = {};

export function lessonRequest(state: SandboxLessonState, isChosen: boolean): SandboxLessonRequest {
  // 🔴 A level/lesson with no script behind it is a 400 that looks no different on screen.
  if (!isChosen) {
    return { error: LESSON_NO_SCRIPTS };
  }

  return { lesson: { level: state.level, lesson: state.lesson, script_index: state.scriptIndex } };
}

export const lessonSummary = ({ level, lesson, scriptIndex }: SandboxLessonState, title?: string) =>
  LESSON_SUMMARY(level, lesson, scriptIndex, title);

export const cursorRequest = (cursor?: AiccSandboxCursor): AiccSandboxCursorRequest | undefined =>
  cursor && { line_idx: cursor.lineIdx, retry_count: cursor.retryCount, intro_emitted: cursor.introEmitted };
